export const OPEN_NOW_CART_SHIPPING_MODAL = 'open-now-cart-shipping-modal'
